var _g, _path, _circle, _circle2, _g2, _ellipse, _ellipse2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 99,
    viewBox: "0 0 179 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Award 6",
    filter: "url(#filter0_d_3684_50708)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36",
    d: "M38.4746 17.0195L38.4746 51.3119L7.74505 51.3119L16.7635 34.1657L0.965256 17.0195L38.4746 17.0195Z",
    fill: "#81599C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 37",
    d: "M129.527 17.0195L129.527 51.3119L160.257 51.3119L151.238 34.1657L167.037 17.0195L129.527 17.0195Z",
    fill: "#81599C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34",
    d: "M29.5684 23.4734L38.4755 17.0195V59.3283H29.5684V23.4734Z",
    fill: "#493A52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 38",
    d: "M138.432 23.4734L129.525 17.0195V59.3283H138.432V23.4734Z",
    fill: "#493A52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M55.4746 23.4434L55.4746 62.6533L27.8281 62.6533C27.8281 62.6533 25.3131 62.6533 25.3131 43.0483C25.3131 23.4434 27.8281 23.4434 27.8281 23.4434L55.4746 23.4434Z",
    fill: "#AA75CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M112.783 23.4434L112.783 62.6533L139.76 62.6533C139.76 62.6533 142.191 62.6533 142.191 43.0483C142.191 23.4434 139.76 23.4434 139.76 23.4434L112.783 23.4434Z",
    fill: "#AA75CB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M84.4405 3.04339C86.4316 1.33338 89.373 1.33338 91.3641 3.04339L94.9149 6.09289C96.1958 7.19297 97.9233 7.61876 99.5688 7.23996L104.13 6.18991C106.688 5.60109 109.292 6.96802 110.261 9.40749L111.988 13.7578C112.61 15.3272 113.942 16.507 115.575 16.9363L120.102 18.1262C122.64 18.7935 124.311 21.2142 124.035 23.8243L123.543 28.4788C123.365 30.1579 123.996 31.8215 125.242 32.9605L128.697 36.1178C130.635 37.8883 130.99 40.8083 129.532 42.991L126.933 46.8835C125.995 48.2877 125.781 50.0539 126.355 51.6417L127.947 56.0431C128.84 58.5112 127.797 61.2615 125.492 62.5169L121.382 64.7556C119.899 65.5631 118.888 67.0274 118.659 68.7002L118.023 73.3374C117.667 75.9378 115.465 77.8883 112.841 77.9287L108.161 78.0007C106.472 78.0267 104.897 78.8535 103.917 80.2282L101.199 84.0388C99.6747 86.1757 96.8188 86.8796 94.4763 85.6958L90.2989 83.5846C88.7919 82.8231 87.0127 82.8231 85.5057 83.5846L81.3283 85.6958C78.9858 86.8796 76.1299 86.1757 74.6058 84.0388L71.888 80.2282C70.9076 78.8535 69.3321 78.0267 67.6439 78.0007L62.9639 77.9287C60.3395 77.8883 58.1379 75.9378 57.7814 73.3374L57.1458 68.7002C56.9165 67.0274 55.9058 65.5631 54.423 64.7556L50.3125 62.5169C48.0076 61.2615 46.9645 58.5112 47.8574 56.0431L49.4496 51.6417C50.0239 50.0539 49.8095 48.2877 48.8718 46.8835L46.2726 42.991C44.815 40.8083 45.1696 37.8883 47.1071 36.1178L50.5624 32.9605C51.8088 31.8215 52.4398 30.1579 52.2621 28.4788L51.7695 23.8243C51.4932 21.2142 53.1641 18.7935 55.7025 18.1262L60.2293 16.9363C61.8623 16.507 63.1941 15.3272 63.817 13.7578L65.5439 9.40749C66.5123 6.96803 69.1168 5.60109 71.6745 6.18991L76.2358 7.23996C77.8812 7.61876 79.6087 7.19297 80.8896 6.09289L84.4405 3.04339Z",
    fill: "url(#paint0_linear_3684_50708)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 87.525,
    cy: 44.1812,
    r: 31.2926,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 16,
    width: 63,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 89.4892,
    cy: 47.6299,
    r: 31.4306,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50708)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 87.8135,
    cy: 44.2822,
    r: 31.4306,
    fill: "url(#paint1_linear_3684_50708)"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 88.2797,
    cy: 44.5571,
    rx: 24.5062,
    ry: 24.8832,
    fill: "#A36D1D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    opacity: 0.8,
    cx: 88.2794,
    cy: 44.5586,
    rx: 22.9981,
    ry: 22.6211,
    fill: "url(#paint2_linear_3684_50708)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88.8944 28.5997L88 26.8108L87.1056 28.5997L82.3449 38.121L72.876 39.3046L70.9832 39.5412L72.2545 40.9633L78.8166 48.304L77.0142 58.8789L76.6828 60.8235L78.4472 59.9413L88 55.1649L97.5528 59.9413L99.314 60.8219L98.986 58.8803L97.1994 48.3039L103.746 40.9624L105.014 39.5409L103.124 39.3046L93.6551 38.121L88.8944 28.5997Z",
    fill: "url(#paint3_linear_3684_50708)",
    stroke: "#C18832",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50708",
    x: 0.181346,
    y: 0.978221,
    width: 178.608,
    height: 97.0418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50708",
    x1: 87.9023,
    y1: 0.0703125,
    x2: 87.9023,
    y2: 89.0467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50708",
    x1: 78.4762,
    y1: 12.8881,
    x2: 101.097,
    y2: 72.8341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3684_50708",
    x1: 88.2794,
    y1: 21.9375,
    x2: 88.2794,
    y2: 67.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3684_50708",
    x1: 88,
    y1: 38.6868,
    x2: 88,
    y2: 57.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#FFFAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestone);
export default __webpack_public_path__ + "static/media/Milestone.85f2ca109fe5c7e138f210d50cc8dfe1.svg";
export { ForwardRef as ReactComponent };